import AuthFooter from './AuthFooter';

export default AuthFooter;
